import { AuthenticateResponse } from './AuthenticateResponse';

export class WebviewAuthenticateResponse extends AuthenticateResponse {
	private credentialId: string;
	private credentialType: string;
	private webViewStartUrl: string;

	constructor(
		postBack: string,
		cancelPostback: string,
		credentialId: string,
		credentialType: string,
		webViewStartUrl: string
	) {
		super(postBack, cancelPostback);
		this.credentialId = credentialId;
		this.credentialType = credentialType;
		this.webViewStartUrl = webViewStartUrl;
	}

	getWebViewStartUrl(): string {
		return this.webViewStartUrl;
	}

	getCredentialId(): string {
		return this.credentialId;
	}

	getCredentialType(): string {
		return this.credentialType;
	}
}
